<script lang="ts">
</script>
<section class="main-intro">
    <div class="container">
        <h1 class="intro-title">F.A.Q.<br>Contact Support Team</h1>
    </div>
</section>

<style>
    .main-intro {
        position: relative;
        padding: 100px 0;
        margin-top: 110px;
    }

    .intro-title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        font-weight: 400;
        color: white;
        margin: 0;
        line-height: 1.5;
        letter-spacing: 3px;
        text-align: center;
    }

    .intro-title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .container {
        position: relative;
    }

    @media(max-width: 1199px) {
        .intro-title {
            font-size: 50px;
        }
    }

    @media(max-width: 991px) {
        .main-intro {
            padding: 100px 0;
        }
    }

    @media(max-width: 767px) {
        .main-intro {
            padding: 50px 0 20px;
            margin-top: 62px;
        }

        .intro-title {
            font-size: 35px;
        }
    }
</style>
